
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2to2n", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $lGgRw = parcelRequire("lGgRw");


var $4kfV4 = parcelRequire("4kfV4");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $56QzY = parcelRequire("56QzY");


var $lqy4C = parcelRequire("lqy4C");


var $de2j9 = parcelRequire("de2j9");


var $7xVCs = parcelRequire("7xVCs");


var $luv00 = parcelRequire("luv00");


var $gz8ZY = parcelRequire("gz8ZY");


var $6adZX = parcelRequire("6adZX");


var $cbBHq = parcelRequire("cbBHq");


var $7EIq6 = parcelRequire("7EIq6");


var $6PMed = parcelRequire("6PMed");


var $cDCEW = parcelRequire("cDCEW");














var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $g5gZt = parcelRequire("g5gZt");


var $eEA8O = parcelRequire("eEA8O");

const $a853228e227f5ed3$var$i18n = (0, $cgtv4.defineMessages)({
    createLabel: {
        id: "create-blank-fabric-page.tree-create-content-button.create-label",
        defaultMessage: "Create"
    },
    createAriaLabelForSpace: {
        id: "create-blank-fabric-page.tree-create-content-button.create-aria-label-for-space",
        defaultMessage: "Create content in this space"
    }
});
const $a853228e227f5ed3$export$ad05072092786bab = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { triggerProps: triggerProps, onClick: onClick, isSelected: isSelected, href: href } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== isSelected) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$IconWrapper, {
            isSelected: isSelected
        }, t1);
        $[1] = isSelected;
        $[2] = t2;
    } else t2 = $[2];
    const icon = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            height: "36px",
            paddingLeft: "10px",
            marginLeft: "0px",
            alignItems: "center"
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== intl) {
        t4 = intl.formatMessage($a853228e227f5ed3$var$i18n.createAriaLabelForSpace);
        $[4] = intl;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a853228e227f5ed3$var$i18n.createLabel);
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== isSelected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$TitleWrapper, {
            isSelected: isSelected
        }, t5);
        $[7] = isSelected;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== href || $[10] !== icon || $[11] !== isSelected || $[12] !== onClick || $[13] !== t4 || $[14] !== t6 || $[15] !== triggerProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            style: t3,
            href: href,
            onClick: onClick,
            isSelected: isSelected,
            testId: "tree-create-content-button",
            "aria-label": t4,
            iconBefore: icon,
            appearance: "subtle",
            shouldFitContainer: true,
            ...triggerProps
        }, t6);
        $[9] = href;
        $[10] = icon;
        $[11] = isSelected;
        $[12] = onClick;
        $[13] = t4;
        $[14] = t6;
        $[15] = triggerProps;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
} : ({ triggerProps: triggerProps, onClick: onClick, isSelected: isSelected, href: href })=>{
    const intl = (0, $8C5kA.default)();
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$IconWrapper, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: ""
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            height: '36px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            paddingLeft: '10px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginLeft: '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center'
        },
        href: href,
        onClick: onClick,
        isSelected: isSelected,
        testId: "tree-create-content-button",
        "aria-label": intl.formatMessage($a853228e227f5ed3$var$i18n.createAriaLabelForSpace),
        iconBefore: icon,
        appearance: "subtle",
        shouldFitContainer: true,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a853228e227f5ed3$var$TitleWrapper, {
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a853228e227f5ed3$var$i18n.createLabel)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a853228e227f5ed3$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syazdgkc",
            __cmplp.isSelected && "_syazxl6c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazdgkc",
            __cmplp.isSelected && "_syazxl6c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $a853228e227f5ed3$var$TitleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { isSelected: isSelected, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _syazazsu _k48pi7a9 _18u01b66",
            __cmplp.isSelected && "_syaz6x5g _k48p1pd9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _syazazsu _k48pi7a9 _18u01b66",
            __cmplp.isSelected && "_syaz6x5g _k48p1pd9",
            __cmplp.className
        ])
    });
});



var $jmjWc = parcelRequire("jmjWc");


const $c577bd07d81ca8a9$export$bcd38c5b8189fb61 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F0d7H",
    name: "ContextualCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("96yiO"))).ContextualCreateContentPopoverMenu
});




















var $lujnM = parcelRequire("lujnM");


var $iI2ST = parcelRequire("iI2ST");

const $8c3f789353c0f876$var$addIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
    label: "",
    color: "currentColor",
    size: "small"
});
const $8c3f789353c0f876$export$eabe3aa0b599cb62 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { onClick: onClick, href: href } = t0;
    if (href) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] !== href || $[2] !== onClick) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
                onClick: onClick,
                elemBefore: $8c3f789353c0f876$var$addIcon,
                href: href
            }, t1);
            $[1] = href;
            $[2] = onClick;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
            onClick: onClick,
            elemBefore: $8c3f789353c0f876$var$addIcon
        }, t1);
        $[5] = onClick;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : ({ onClick: onClick, href: href })=>{
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lujnM.LinkMenuItem), {
        onClick: onClick,
        elemBefore: $8c3f789353c0f876$var$addIcon,
        href: href
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iI2ST.ButtonMenuItem), {
        onClick: onClick,
        elemBefore: $8c3f789353c0f876$var$addIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $8c3f789353c0f876$var$i18n.create));
};
const $8c3f789353c0f876$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create-content-menu-item.create",
        defaultMessage: "Create"
    }
});


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a7a1bff19d06ba1$var$TriggerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_80om73ad",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80om73ad",
            __cmplp.className
        ])
    });
});
const $0a7a1bff19d06ba1$var$customPopupContainerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'radius.small',
    ':focus': {
        outline: 'none'
    }
});
const $0a7a1bff19d06ba1$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, popupRef)=>{
    const $ = (0, $frIzR.c)(9);
    let children;
    let dataTestId;
    let props;
    if ($[0] !== t0) {
        ({ children: children, "data-testid": dataTestId, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = dataTestId;
        $[3] = props;
    } else {
        children = $[1];
        dataTestId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== children || $[5] !== dataTestId || $[6] !== popupRef || $[7] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: dataTestId,
            ...props,
            ref: popupRef,
            xcss: $0a7a1bff19d06ba1$var$customPopupContainerStyles
        }, children);
        $[4] = children;
        $[5] = dataTestId;
        $[6] = popupRef;
        $[7] = props;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : ({ children: children, 'data-testid': dataTestId, ...props }, popupRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: dataTestId,
        ...props,
        ref: popupRef,
        xcss: $0a7a1bff19d06ba1$var$customPopupContainerStyles
    }, children));
const $0a7a1bff19d06ba1$export$a659f5fb9e1f688c = [
    0,
    8
];
const $0a7a1bff19d06ba1$export$79699783f82a969e = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(51);
    const { closeAllHoverPageCards: closeAllHoverPageCards, isContextualCreateFocused: isContextualCreateFocused, setIsContextualCreateFocused: setIsContextualCreateFocused, spaceKey: spaceKey, parentId: parentId, source: source, displayTitle: displayTitle, rootCreateButtonStyling: t1, shouldShowPopup: shouldShowPopup, setShouldShowPopup: setShouldShowPopup, isTreeItem: isTreeItem, placement: t2, offset: t3, onItemClick: onItemClick, shouldRenderToParent: shouldRenderToParent, hideFolder: hideFolder, contentType: contentType } = t0;
    const rootCreateButtonStyling = t1 === undefined ? false : t1;
    let placement = t2 === undefined ? "right-start" : t2;
    let offset = t3 === undefined ? [
        -10,
        8
    ] : t3;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t4;
    if ($[0] !== shouldShowPopup) {
        t4 = ()=>!!shouldShowPopup;
        $[0] = shouldShowPopup;
        $[1] = t4;
    } else t4 = $[1];
    const [isOpen, setIsOpen] = (0, $42omo.useState)(t4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (isNav4Enabled) {
        placement = "bottom-start";
        offset = $0a7a1bff19d06ba1$export$a659f5fb9e1f688c;
    }
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            source: "page-tree-contextual-create"
        };
        $[2] = t5;
    } else t5 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t5);
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    let t6;
    if ($[3] !== preloadCreationMenuData || $[4] !== preloadSmartCreationModal) {
        t6 = ()=>{
            preloadCreationMenuData();
            preloadSmartCreationModal();
            (0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61).preload();
        };
        $[3] = preloadCreationMenuData;
        $[4] = preloadSmartCreationModal;
        $[5] = t6;
    } else t6 = $[5];
    const preloadCreationMenu = t6;
    const stopEvents = $0a7a1bff19d06ba1$var$_temp;
    let t7;
    if ($[6] !== closeFlyout || $[7] !== isNav4Enabled) {
        t7 = (event_0)=>{
            if (isNav4Enabled) closeFlyout();
            stopEvents(event_0);
        };
        $[6] = closeFlyout;
        $[7] = isNav4Enabled;
        $[8] = t7;
    } else t7 = $[8];
    const handleOnClick = t7;
    let t8;
    if ($[9] !== closeAllHoverPageCards || $[10] !== createAnalyticsEvent || $[11] !== isContextualCreateFocused || $[12] !== isOnEditRoute || $[13] !== isOpen || $[14] !== setIsContextualCreateFocused || $[15] !== setIsOpen || $[16] !== setShouldShowPopup || $[17] !== source) {
        t8 = ()=>{
            setIsContextualCreateFocused?.(!isContextualCreateFocused);
            closeAllHoverPageCards?.();
            setIsOpen(!isOpen);
            setShouldShowPopup?.(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "contextualCreateButton",
                    actionSubjectId: source,
                    source: "containerNavigation",
                    attributes: {
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[9] = closeAllHoverPageCards;
        $[10] = createAnalyticsEvent;
        $[11] = isContextualCreateFocused;
        $[12] = isOnEditRoute;
        $[13] = isOpen;
        $[14] = setIsContextualCreateFocused;
        $[15] = setIsOpen;
        $[16] = setShouldShowPopup;
        $[17] = source;
        $[18] = t8;
    } else t8 = $[18];
    const onTriggerClick = t8;
    let t9;
    if ($[19] !== setIsContextualCreateFocused || $[20] !== setIsOpen || $[21] !== setShouldShowPopup) {
        t9 = ()=>{
            const activeEle = document.activeElement;
            activeEle?.blur();
            setIsOpen(false);
            setShouldShowPopup?.(false);
            setTimeout(()=>{
                setIsContextualCreateFocused?.(false);
            }, 0);
        };
        $[19] = setIsContextualCreateFocused;
        $[20] = setIsOpen;
        $[21] = setShouldShowPopup;
        $[22] = t9;
    } else t9 = $[22];
    const onCloseHandler = t9;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateFolderEnabled: isCreateFolderEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t10;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $7xVCs.PageTreeStateUpdater)
        ];
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== contentType || $[25] !== displayTitle || $[26] !== enforceStorageLimit || $[27] !== handleOnClick || $[28] !== hideFolder || $[29] !== isContextualCreateFocused || $[30] !== isCreateDatabaseEnabled || $[31] !== isCreateFolderEnabled || $[32] !== isCreateLiveDocEnabled || $[33] !== isCreateSmartLinkEnabled || $[34] !== isCreateWhiteboardEnabled || $[35] !== isNav4Enabled || $[36] !== isOpen || $[37] !== isTreeItem || $[38] !== offset || $[39] !== onCloseHandler || $[40] !== onItemClick || $[41] !== onTriggerClick || $[42] !== parentId || $[43] !== placement || $[44] !== preloadCreationMenu || $[45] !== rootCreateButtonStyling || $[46] !== shouldRenderToParent || $[47] !== source || $[48] !== spaceKey || $[49] !== ssrPlaceholderIdProp) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t10
        }, (pageStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "contextual-create-blanket",
                isTinted: false,
                onBlanketClicked: onCloseHandler
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
                isOpen: isOpen,
                onClose: onCloseHandler,
                placement: placement,
                offset: offset,
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61), {
                        source: source,
                        parentId: parentId,
                        isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                        isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                        isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                        isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                        isCreateFolderEnabled: isCreateFolderEnabled && !hideFolder,
                        onCloseMenu: onCloseHandler,
                        pageStateUpdater: pageStateUpdater,
                        onItemClick: onItemClick,
                        parentTitle: displayTitle,
                        parentContentType: contentType
                    }),
                popupComponent: shouldRenderToParent ? $0a7a1bff19d06ba1$var$CustomPopupContainer : undefined,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a7a1bff19d06ba1$var$TriggerContainer, {
                        onClick: handleOnClick,
                        onFocus: stopEvents,
                        onBlur: stopEvents,
                        "data-vc": "contextual-create-content-popover",
                        ...ssrPlaceholderIdProp
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                        onMouseEnter: preloadCreationMenu,
                        onFocus: preloadCreationMenu
                    }, isTreeItem ? isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c3f789353c0f876$export$eabe3aa0b599cb62), {
                        onClick: enforceStorageLimit(onTriggerClick)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a853228e227f5ed3$export$ad05072092786bab), {
                        triggerProps: triggerProps,
                        onClick: enforceStorageLimit(onTriggerClick),
                        isSelected: isOpen
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cDCEW.ContextualCreateContentButton), {
                        onClick: enforceStorageLimit(onTriggerClick),
                        triggerProps: triggerProps,
                        isContextualCreateFocused: isContextualCreateFocused,
                        spaceKey: spaceKey,
                        rootCreateButtonStyling: rootCreateButtonStyling,
                        displayTitle: displayTitle
                    })), !shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                        testId: "contextual-create-blanket",
                        isTinted: false,
                        onBlanketClicked: onCloseHandler
                    })),
                shouldRenderToParent: shouldRenderToParent,
                testId: "contextual-create-popover"
            })));
        $[24] = contentType;
        $[25] = displayTitle;
        $[26] = enforceStorageLimit;
        $[27] = handleOnClick;
        $[28] = hideFolder;
        $[29] = isContextualCreateFocused;
        $[30] = isCreateDatabaseEnabled;
        $[31] = isCreateFolderEnabled;
        $[32] = isCreateLiveDocEnabled;
        $[33] = isCreateSmartLinkEnabled;
        $[34] = isCreateWhiteboardEnabled;
        $[35] = isNav4Enabled;
        $[36] = isOpen;
        $[37] = isTreeItem;
        $[38] = offset;
        $[39] = onCloseHandler;
        $[40] = onItemClick;
        $[41] = onTriggerClick;
        $[42] = parentId;
        $[43] = placement;
        $[44] = preloadCreationMenu;
        $[45] = rootCreateButtonStyling;
        $[46] = shouldRenderToParent;
        $[47] = source;
        $[48] = spaceKey;
        $[49] = ssrPlaceholderIdProp;
        $[50] = t11;
    } else t11 = $[50];
    return t11;
} : ({ closeAllHoverPageCards: closeAllHoverPageCards, isContextualCreateFocused: isContextualCreateFocused, setIsContextualCreateFocused: setIsContextualCreateFocused, spaceKey: spaceKey, parentId: parentId, source: source, displayTitle: displayTitle, rootCreateButtonStyling: rootCreateButtonStyling = false, shouldShowPopup: shouldShowPopup, setShouldShowPopup: setShouldShowPopup, isTreeItem: isTreeItem, placement: placement = 'right-start', offset: offset = [
    -10,
    8
], onItemClick: onItemClick, shouldRenderToParent: shouldRenderToParent, hideFolder: hideFolder, contentType: contentType })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(()=>!!shouldShowPopup);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (isNav4Enabled) {
        placement = 'bottom-start';
        offset = $0a7a1bff19d06ba1$export$a659f5fb9e1f688c;
    }
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'page-tree-contextual-create'
    });
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const preloadCreationMenu = ()=>{
        preloadCreationMenuData();
        preloadSmartCreationModal();
        (0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61).preload();
    };
    const stopEvents = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        event.preventDefault();
    }, []);
    const handleOnClick = (0, $42omo.useCallback)((event_0)=>{
        if (isNav4Enabled) closeFlyout();
        stopEvents(event_0);
    }, [
        isNav4Enabled,
        stopEvents,
        closeFlyout
    ]);
    const onTriggerClick = (0, $42omo.useCallback)(()=>{
        setIsContextualCreateFocused?.(!isContextualCreateFocused);
        closeAllHoverPageCards?.();
        setIsOpen(!isOpen);
        setShouldShowPopup?.(!isOpen);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'contextualCreateButton',
                actionSubjectId: source,
                source: 'containerNavigation',
                attributes: {
                    navdexPointType: (0, $56QzY.START),
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        isOpen,
        setIsOpen,
        setShouldShowPopup,
        closeAllHoverPageCards,
        isContextualCreateFocused,
        setIsContextualCreateFocused,
        createAnalyticsEvent,
        source,
        isOnEditRoute
    ]);
    const onCloseHandler = (0, $42omo.useCallback)(()=>{
        // The bluring of the active element should be temporary, see this ticket for an explanation: https://hello.atlassian.net/browse/CCT-906
        const activeEle = document.activeElement; // @ts-ignore
        activeEle?.blur();
        setIsOpen(false);
        setShouldShowPopup?.(false); // This needs to be set after the focus returns to the trigger button
        setTimeout(()=>{
            setIsContextualCreateFocused?.(false);
        }, 0);
    }, [
        setIsOpen,
        setShouldShowPopup,
        setIsContextualCreateFocused
    ]);
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateFolderEnabled: isCreateFolderEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>// rendering popup to parent for a11y purposes was causing issues for contextual create on tree items in the page tree
        // so popup is rendered to parent based on whether shouldRenderToParent prop is true
        // TODO: DISCO-2052 resolve this issue and render to parent for all cases
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
            testId: "contextual-create-blanket",
            isTinted: false,
            onBlanketClicked: onCloseHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: onCloseHandler,
            placement: placement,
            offset: offset,
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c577bd07d81ca8a9$export$bcd38c5b8189fb61), {
                    source: source,
                    parentId: parentId,
                    isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                    isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                    isCreateSmartLinkEnabled: isCreateSmartLinkEnabled,
                    isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                    isCreateFolderEnabled: isCreateFolderEnabled && !hideFolder,
                    onCloseMenu: onCloseHandler,
                    pageStateUpdater: pageStateUpdater,
                    onItemClick: onItemClick,
                    parentTitle: displayTitle,
                    parentContentType: contentType
                }),
            popupComponent: shouldRenderToParent ? $0a7a1bff19d06ba1$var$CustomPopupContainer : undefined,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0a7a1bff19d06ba1$var$TriggerContainer, {
                    onClick: handleOnClick,
                    onFocus: stopEvents,
                    onBlur: stopEvents,
                    "data-vc": "contextual-create-content-popover",
                    ...ssrPlaceholderIdProp
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                    onMouseEnter: preloadCreationMenu,
                    onFocus: preloadCreationMenu
                }, isTreeItem ? isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8c3f789353c0f876$export$eabe3aa0b599cb62), {
                    onClick: enforceStorageLimit(onTriggerClick)
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a853228e227f5ed3$export$ad05072092786bab), {
                    triggerProps: triggerProps,
                    onClick: enforceStorageLimit(onTriggerClick),
                    isSelected: isOpen
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cDCEW.ContextualCreateContentButton), {
                    onClick: enforceStorageLimit(onTriggerClick),
                    triggerProps: triggerProps,
                    isContextualCreateFocused: isContextualCreateFocused,
                    spaceKey: spaceKey,
                    rootCreateButtonStyling: rootCreateButtonStyling,
                    displayTitle: displayTitle
                })), !shouldRenderToParent && isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                    testId: "contextual-create-blanket",
                    isTinted: false,
                    onBlanketClicked: onCloseHandler
                })),
            shouldRenderToParent: shouldRenderToParent,
            testId: "contextual-create-popover"
        })));
};
function $0a7a1bff19d06ba1$var$_temp(event) {
    event.stopPropagation();
    event.preventDefault();
}
module.exports["NAV4_POPOVER_OFFSET"] = $0a7a1bff19d06ba1$export$a659f5fb9e1f688c;
module.exports["ContextualCreateContentPopover"] = $0a7a1bff19d06ba1$export$79699783f82a969e;

});

parcelRegister("cDCEW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eSUdr = parcelRequire("eSUdr");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $3gadb = parcelRequire("3gadb");


var $g5gZt = parcelRequire("g5gZt");


var $5izcQ = parcelRequire("5izcQ");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $b3j2Y = parcelRequire("b3j2Y");


var $gz8ZY = parcelRequire("gz8ZY");


var $jtuBN = parcelRequire("jtuBN");

const $6e1fd29dfbf932de$var$i18n = (0, $cgtv4.defineMessages)({
    simpleCreateLabel: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label",
        defaultMessage: "Create"
    },
    simpleCreateLabelForTitle: {
        id: "create-blank-fabric-page.contextual-create.button.simple-create-label-for-title",
        defaultMessage: "Create child content for {pageTitle}"
    }
});
const $6e1fd29dfbf932de$var$canCreateContent = (data)=>{
    return (0, $2wo33.canPerformSpaceOperation)({
        operationCheckResult: data,
        operation: (0, $lfBMY.OperationTypes).CREATE,
        contentType: 'page'
    });
};
const $6e1fd29dfbf932de$export$e5aab90af54da00f = (isOpen)=>{
    return isOpen ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides -- To migrate as part of go/ui-styling-standard
const $6e1fd29dfbf932de$var$ContextualCreateButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $1qfLF.default) : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_147mbvz": (0, $7sObp.default)($6e1fd29dfbf932de$export$e5aab90af54da00f(__cmplp.isOpen))
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1efsqup9",
                __cmplp.isRootCreateButton ? "_i2zu1q3r" : "_i2zu1kw7",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $1qfLF.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_147mbvz": (0, $7sObp.default)($6e1fd29dfbf932de$export$e5aab90af54da00f(__cmplp.isOpen))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1efsqup9",
            __cmplp.isRootCreateButton ? "_i2zu1q3r" : "_i2zu1kw7",
            __cmplp.className
        ])
    });
});
const $6e1fd29dfbf932de$export$613f902834bf164 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { triggerProps: triggerProps, onClick: onClick, isContextualCreateFocused: isContextualCreateFocused, spaceKey: spaceKey, rootCreateButtonStyling: rootCreateButtonStyling, displayTitle: displayTitle } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== spaceKey) {
        t2 = {
            variables: {
                spaceKey: spaceKey
            }
        };
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(t1, t2);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t3;
    if ($[3] !== onClick) {
        t3 = (e)=>{
            onClick(e);
        };
        $[3] = onClick;
        $[4] = t3;
    } else t3 = $[4];
    const handleClick = t3;
    if (error) {
        let t4;
        if ($[5] !== error) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[5] = error;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const canCreate = data && $6e1fd29dfbf932de$var$canCreateContent(data);
    if (loading || !canCreate) return null;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== intl || $[9] !== isNav4Enabled) {
        t5 = ()=>isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel)
            });
        $[8] = intl;
        $[9] = isNav4Enabled;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== displayTitle || $[12] !== intl) {
        t6 = displayTitle ? intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabelForTitle, {
            pageTitle: displayTitle
        }) : intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel);
        $[11] = displayTitle;
        $[12] = intl;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== handleClick || $[15] !== isContextualCreateFocused || $[16] !== rootCreateButtonStyling || $[17] !== t5 || $[18] !== t6 || $[19] !== triggerProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "pagetree-createcontent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t4,
            position: "top",
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "enhance-orientation-spotlight-tour-target-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1fd29dfbf932de$var$ContextualCreateButton, {
            ...triggerProps,
            id: "contextual-create-content-button",
            appearance: "subtle",
            icon: t5,
            label: t6,
            onClick: handleClick,
            testId: "contextual-create-content-button",
            isSelected: isContextualCreateFocused,
            isOpen: isContextualCreateFocused,
            isRootCreateButton: rootCreateButtonStyling,
            spacing: "compact"
        }))));
        $[14] = handleClick;
        $[15] = isContextualCreateFocused;
        $[16] = rootCreateButtonStyling;
        $[17] = t5;
        $[18] = t6;
        $[19] = triggerProps;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ triggerProps: triggerProps, onClick: onClick, isContextualCreateFocused: isContextualCreateFocused, spaceKey: spaceKey, rootCreateButtonStyling: rootCreateButtonStyling, displayTitle: displayTitle })=>{
    const intl = (0, $8C5kA.default)();
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $eSUdr.default)`query ContextualCreateContentButtonQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`, {
        variables: {
            spaceKey: spaceKey
        }
    });
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        onClick(e);
    }, [
        onClick
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    const canCreate = data && $6e1fd29dfbf932de$var$canCreateContent(data);
    if (loading || !canCreate) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "pagetree-createcontent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
        position: "top",
        hideTooltipOnMouseDown: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6e1fd29dfbf932de$var$ContextualCreateButton, {
        ...triggerProps,
        id: "contextual-create-content-button",
        appearance: "subtle",
        icon: ()=>isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel)
            }),
        label: displayTitle ? intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabelForTitle, {
            pageTitle: displayTitle
        }) : intl.formatMessage($6e1fd29dfbf932de$var$i18n.simpleCreateLabel),
        onClick: handleClick,
        testId: "contextual-create-content-button",
        isSelected: isContextualCreateFocused,
        isOpen: isContextualCreateFocused,
        isRootCreateButton: rootCreateButtonStyling,
        spacing: "compact"
    }))));
};
module.exports["contextualCreateContentIconSVGColor"] = $6e1fd29dfbf932de$export$e5aab90af54da00f;
module.exports["ContextualCreateContentButton"] = $6e1fd29dfbf932de$export$613f902834bf164;

});

parcelRegister("96yiO", function(module, exports) {

let $6a0f48561cdd786d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6a0f48561cdd786d$var$load("1FaWw"),
    $6a0f48561cdd786d$var$load("lXGg9"),
    $6a0f48561cdd786d$var$load("hy3sK"),
    $6a0f48561cdd786d$var$load("jTaSF"),
    $6a0f48561cdd786d$var$load("nbjnv"),
    $6a0f48561cdd786d$var$load("6wr18"),
    $6a0f48561cdd786d$var$load("gMN6Z"),
    $6a0f48561cdd786d$var$load("aDPqY"),
    $6a0f48561cdd786d$var$load("kt4iH"),
    $6a0f48561cdd786d$var$load("i1fZC"),
    $6a0f48561cdd786d$var$load("iAqyW"),
    $6a0f48561cdd786d$var$load("clQc9"),
    $6a0f48561cdd786d$var$load("8PPsf"),
    $6a0f48561cdd786d$var$load("4eboO"),
    $6a0f48561cdd786d$var$load("5U3YO"),
    $6a0f48561cdd786d$var$load("8YSo7"),
    $6a0f48561cdd786d$var$load("fD0v8"),
    $6a0f48561cdd786d$var$load("6ZsQ4"),
    $6a0f48561cdd786d$var$load("6XCf4"),
    $6a0f48561cdd786d$var$load("5pvpJ"),
    $6a0f48561cdd786d$var$load("Wowvf"),
    $6a0f48561cdd786d$var$load("36QeB"),
    $6a0f48561cdd786d$var$load("ffEVr"),
    $6a0f48561cdd786d$var$load("1qlDN"),
    $6a0f48561cdd786d$var$load("1yVM6"),
    $6a0f48561cdd786d$var$load("hhss7"),
    $6a0f48561cdd786d$var$load("gZGoR"),
    $6a0f48561cdd786d$var$load("let0D"),
    $6a0f48561cdd786d$var$load("joFPh"),
    $6a0f48561cdd786d$var$load("75V2Q"),
    $6a0f48561cdd786d$var$load("ZZR2T"),
    $6a0f48561cdd786d$var$load("7EorR"),
    $6a0f48561cdd786d$var$load("4Dabn")
]).then(()=>parcelRequire('7yriZ'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});


//# sourceMappingURL=TreeBottomCreateButton.9c5823bd.js.map
